import ItemStockLogScreen from './stock_log';

const routes = [
  {
    path: '/report/stock/log',
    component: ItemStockLogScreen,
    action: ['read_only', 'manage'],
    service: 'nvo.wms.stock',
  }
];

export default routes;
